function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-343 -208)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 7",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(343 208)",
  fill: "#002f4d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-calendar-check",
  d: "M360.06 217.426h-10.33a.292.292 0 01-.292-.294v-.877a1.169 1.169 0 011.169-1.17h1.17v-1.267a.292.292 0 01.292-.292h.975a.292.292 0 01.294.292v1.267h3.117v-1.267a.292.292 0 01.292-.292h.975a.292.292 0 01.292.292v1.267h1.169a1.169 1.169 0 011.169 1.169v.877a.292.292 0 01-.292.295zm-10.33.78h10.33a.292.292 0 01.292.292v6.328a1.169 1.169 0 01-1.169 1.169h-8.576a1.169 1.169 0 01-1.169-1.169v-6.33a.292.292 0 01.292-.292zm8.12 2.338l-.686-.692a.292.292 0 00-.413 0l-2.584 2.558-1.12-1.129a.292.292 0 00-.413 0l-.696.685a.292.292 0 000 .413l2.012 2.029a.292.292 0 00.413 0l3.486-3.453a.292.292 0 000-.413z",
  fill: "#fdfdfd"
}));
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};
export default SvgCalendar;